var _circle, _circle2, _circle3, _path, _line, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 67,
    r: 36,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 94,
    r: 36,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 36,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 209H235C235 169.235 208.137 137 175 137C141.863 137 115 169.235 115 209Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 205,
    x2: 229,
    y2: 205,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5943 73.4471C45.4543 70.7227 45.1175 65.9687 47.8419 62.8287C50.5663 59.6887 55.3203 59.3518 58.4603 62.0763L66.4106 68.9744L61.5824 74.637L67.4103 79.6061L69.8189 76.7811C69.59 78.0781 69.0177 79.3316 68.0918 80.3987C65.3674 83.5387 60.6134 83.8755 57.4734 81.1511L48.5943 73.4471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1008 53.5314C84.3416 50.4219 79.5841 50.1379 76.4746 52.897L56.4375 70.6762L61.6987 76.5034L62.6481 77.2941L62.5351 77.4298L66.5264 81.8506L86.4663 64.1576C89.5758 61.3984 89.8599 56.6409 87.1008 53.5314Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 297.031,
    y: 49.3225,
    width: 7.52719,
    height: 42.4454,
    rx: 3.7636,
    transform: "rotate(45 297.031 49.3225)",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.52719
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 266.323,
    y: 55.4219,
    width: 7.52719,
    height: 42.4454,
    rx: 3.7636,
    transform: "rotate(-45 266.323 55.4219)",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.52719
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.c0534f951ca9b4dd0cbdd826c8c6f418.svg";
export { ForwardRef as ReactComponent };